import { BaseService } from '../types/index.js';
export class Common extends BaseService {
    saveData(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/tab/complete',
            headers: {
                Accept: 'text/plain;v=1.0',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params),
        });
    }
    getSecondaryMail() {
        return this._request.send({
            method: 'GET',
            url: '/api/app/account/secondary/email',
        });
    }
    verifySecondaryMail(params) {
        return this._request.send(Object.assign({ method: 'POST', url: '/api/app/account/secondary/email/verify' }, params));
    }
    checkSecondaryMail(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/verifyCode/secondary/email',
            params,
        });
    }
    setSecondaryMail(params) {
        return this._request.send({
            method: 'POST',
            url: '/api/app/account/set/secondary/email',
            params,
        });
    }
}
